import { defineComponent, reactive, createVNode } from 'vue';
import { Button, Modal as AntModal } from 'ant-design-vue';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import { modalProps } from './props';
import { getPrefixCls, getPropSlot } from '../_utils/props-tools';
import MiTeleport from './teleport';
import MiPopup from './popup';
const Modal = defineComponent({
    name: 'MiModal',
    inheritAttrs: false,
    props: modalProps(),
    emits: ['ok', 'cancel', 'update:visible'],
    slots: Object,
    setup(props, { slots, attrs, emit }) {
        const { t } = useI18n();
        const prefixCls = getPrefixCls('modal', props.prefixCls);
        const handleOk = (evt) => {
            emit('ok', evt);
        };
        const handleCancel = (evt) => {
            emit('update:visible', false);
            emit('cancel', evt);
        };
        const renderClose = () => {
            return (<span class={`${prefixCls}-close-x`}>
                    {getPropSlot(slots, props, 'closeIcon') ?? (<CloseOutlined class={`${prefixCls}-close-icon`}/>)}
                </span>);
        };
        const renderFooter = () => {
            return (<div class={`${prefixCls}-btns`}>
                    <Button type="default" class={`${prefixCls}-btn`} onClick={handleCancel}>
                        {getPropSlot(slots, props, 'cancelText') ?? t('cancel')}
                    </Button>
                    <Button type="primary" class={`${prefixCls}-btn-primary`} onClick={handleOk}>
                        {getPropSlot(slots, props, 'okText') ?? t('ok')}
                    </Button>
                </div>);
        };
        return () => {
            let propties = reactive({
                ...props,
                ...attrs,
                prefixCls,
                title: getPropSlot(slots, props, 'title') ?? t('kind-tips'),
                footer: getPropSlot(slots, props, 'footer') ?? renderFooter(),
                closeIcon: renderClose(),
                onCancel: handleCancel
            });
            return props.container === false ? (<MiPopup {...propties}>{getPropSlot(slots, props)}</MiPopup>) : (<MiTeleport visible={props.visible} forceRender={props.forceRender} container={props.container} children={(child) => {
                    propties = { ...propties, ...child };
                    return <MiPopup {...propties}>{getPropSlot(slots, props)}</MiPopup>;
                }}/>);
        };
    }
});
const prefixCls = getPrefixCls('modal');
const defaultConfig = {
    centered: true,
    keyboard: true,
    mask: true,
    maskClosable: true,
    width: 360,
    okText: '知道了'
};
const mergeConfig = (config, type) => {
    if (typeof config === 'string')
        config = { content: config };
    return Object.assign({}, defaultConfig, {
        class: `${prefixCls}-${type}`
    }, config);
};
Modal.info = (config) => {
    AntModal.info(mergeConfig(config, 'info'));
};
Modal.success = (config) => {
    AntModal.success(mergeConfig(config, 'success'));
};
Modal.error = (config) => {
    AntModal.error(mergeConfig(config, 'error'));
};
Modal.warn = (config) => {
    AntModal.warning(mergeConfig(config, 'warning'));
};
Modal.warning = (config) => {
    AntModal.warning(mergeConfig(config, 'warning'));
};
Modal.confirm = (config) => {
    const configuration = Object.assign({}, mergeConfig(config, 'confirm'), {
        icon: createVNode(QuestionCircleOutlined),
        okText: '确定',
        cancelText: '取消'
    });
    AntModal.confirm(configuration);
};
Modal.destroyAll = () => {
    AntModal.destroyAll();
};
export default Modal;
